import 'debug';
import { d as pageMixin } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';

//
var script = {
  mixins: [pageMixin],
  data: function data() {
    return {
      answerSectionID: null
    };
  },
  computed: {
    scrollable: function scrollable() {
      return parseInt(this.pageData.Scrollable) === 1;
    } // ,
    // ...mapGetters('nav', 'currentEntry')

  },
  created: function created() {},
  mounted: function mounted() {// TODO: if (!settings.repeatMultipleChoiceQuestions) this.answerSectionID = getItFromStore
  },
  methods: {
    selectAnswer: function selectAnswer(sectionID) {
      this.answerSectionID = sectionID; // TODO: save Answer to store
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "o-multiple-choice-page c-multiple-choice-page" },
    [
      _c(
        "xp-section",
        { staticClass: "question" },
        [
          _vm._l(this.pageData.Sections[0].entries, function(entry) {
            return _c("dynamic-entry", {
              key: entry.ID,
              attrs: { entryData: entry, id: "entry-" + entry.ID }
            })
          }),
          _vm._v(" "),
          _c(
            "ul",
            { attrs: { id: "c-answer-selection" } },
            _vm._l(
              _vm.pageData.Sections.filter(function(item, index) {
                return (
                  _vm.answerSectionID == null && index > 0 && item.Title > ""
                )
              }),
              function(section) {
                return _c(
                  "li",
                  { key: section.ID, class: "answer" + section.ID + " answer" },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return _vm.selectAnswer(section.ID)
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "xp xp--medium xp-arrow-forward"
                        }),
                        _c("span", { staticClass: "question-title" }, [
                          _vm._v(_vm._s(section.Title))
                        ])
                      ]
                    )
                  ]
                )
              }
            ),
            0
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(
        _vm.pageData.Sections.filter(function(item, index) {
          return index > 0 && item.Title > ""
        }),
        function(section) {
          return _c(
            "xp-section",
            {
              key: section.ID,
              class:
                "o-section answer" +
                section.ID +
                " answer" +
                (section.ID == _vm.answerSectionID ? " selected" : "")
            },
            [
              _c("span", { staticClass: "question-title answered" }, [
                _vm._v(_vm._s(section.Title))
              ]),
              _vm._v(" "),
              _vm._l(section.entries, function(entry) {
                return _c("dynamic-entry", {
                  key: entry.ID,
                  attrs: { entryData: entry, id: "entry-" + entry.ID }
                })
              })
            ],
            2
          )
        }
      ),
      _vm._v(" "),
      _vm.$xp.navigation.isAudioSynced
        ? _c("audio-player", {
            attrs: {
              source:
                _vm.$xp.settings.baseUrl + "xpedeo/" + _vm.pageData.Audio.Url,
              binaryId: _vm.pageData.Audio.BinaryID,
              pageId: _vm.pageData.ID,
              audioSync: _vm.pageData.AudioSync,
              autoPlay: _vm.$xp.settings.autoPlayPageAudio,
              lipSyncUrl:
                _vm.pageData.Class === "XpVideoSync"
                  ? _vm.pageData.lipSyncUrl
                  : null
            }
          })
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
